import { render, staticRenderFns } from "./QuarterSheet.vue?vue&type=template&id=20152db6"
import script from "./QuarterSheet.vue?vue&type=script&lang=js"
export * from "./QuarterSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports